export default {
    languageList(state) {
        return state.languageList;
    },
    activeLanguageList(state) {
        return state.activeLanguageList;
    },
    translatedText(state){
        return state.translatedText;
    },
    identifyedLanguage(state){
        return state.identifyedLanguage;
    }
}